import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsEnums } from "../../shared/dto/aps.enums";
import { StateParams } from "../../common";
import { apsEvents } from "../../shared/dto/aps.events";
import { NavigationModel, Plant } from "../../models/navigation";
import AuthDataServiceName, { AuthDataService, RoleLocation } from "../../services/auth/authData.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import CheckListsServiceName, { CheckListsService } from "../../services/checkLists/checkLists.service";
import { States } from "../../shared/config/constant.module";
import KPIChecksHubName, { KPIChecksHub, KPIChecksHubService } from "../../services/checkLists/kpiChecks.hub";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
let requires = [LoaderServiceName, CheckListsServiceName, KPIChecksHubName, NavigationServiceName, AuthDataServiceName];

interface HourEntry {
  hour: number;
  utcHour: number;
  paddedHour: string;
}

interface HourStatus {
  result: string;
  status: apsEnums.CheckStatus;
  isCaution: boolean;
  jobRunId: string;
}
interface DailyStatus {
  result: string;
  status: apsEnums.CheckStatus;
  isCaution: boolean;
}

interface ShopJobItem {
  shop: apsViewModels.ShopNavigation;
  jobRun: apsViewModels.JobRunConfiguration;
  hours: HourStatus[];
  dailies: DailyStatus[];
  index: number;
  day: number;
  jobRunCount: number;
}

interface HourlyCheckReportController {
  plant: Plant;
  numHours: number;
  wellKnownCheck: apsEnums.WellKnownCheckType;
  shopJobItems: ShopJobItem[];
  hours: HourEntry[];
  hubs: KPIChecksHub[];
  hourlyReportItems: apsViewModels.HourlyCheckReportShopItem[];
  navigation: NavigationModel;
  plantAvg: string;
  showDetails: boolean;
  zoomableStyle: string;
  showYieldColumn: boolean;

  goToShopDashboard(plant: Plant, shop: apsViewModels.ShopNavigation): void;
  goToProductionSummary(plant: Plant, shop: apsViewModels.ShopNavigation): void;
  toggleHidding(): void;
}

export default angular.module('aps.controller.hourlyCheckReport', requires)
  .controller('HourlyCheckReportCtrl', hourlyCheckReportCtrl)
  .name;

function calculateDay(jobRun: apsViewModels.JobRunConfiguration): number {
  return moment().diff(moment(jobRun.startDate), 'days') + 1;
}

function hourlyCheckReportCtrl(
  loaderService: LoaderService,
  checkListsService: CheckListsService,
  navigationService: NavigationService,
  kpiChecksHubService: KPIChecksHubService,
  authDataService: AuthDataService,
  $scope: angular.IScope,
  $timeout: angular.ITimeoutService,
  $stateParams: StateParams,
  $state: angular.ui.IStateService
): HourlyCheckReportController {
  let vm = this as HourlyCheckReportController;
  let dataTimeout = [];
  vm.hubs = [];
  RefreshScreen(true, false);

  $scope.$on('$destroy', () => {
    if (vm.hubs) {
      _.forEach(vm.hubs, h => h.uninitialize());
    }
    vm.hubs = [];
    dataTimeout.forEach(function (timeout) {
      $timeout.cancel(timeout);
    });
    dataTimeout = [];
    RefreshScreen(false, true);
  });

  function RefreshScreen(firsttime: boolean, topofthehour: boolean) {
    if (topofthehour) {
      var now = new Date();
      var topOfTheHour = ((59 - now.getMinutes()) * 60000) + ((59 - now.getSeconds()) * 1000) + 5000;
      $timeout(() => {
        var currentHour = createHourEntry(0, new Date());
        vm.hours.unshift(currentHour);
        vm.hours.splice(vm.hours.length - 1, 1);

        _.forEach(vm.shopJobItems, (i: ShopJobItem) => {
          i.hours.unshift({ result: null, status: apsEnums.CheckStatus.NotDone, isCaution: false, jobRunId: null });
          i.hours.splice(vm.hours.length - 1, 1);
        });

        RefreshScreen(false, true);
      }, topOfTheHour);
    }
    else {
      let refreshtime = 0;
      if (firsttime)
        refreshtime;
      else {
        refreshtime = (((~(new Date().getMinutes() / 20) * 20) * -1) - new Date().getMinutes()) * 60000;
      }
      var timeOut = $timeout(() => {
        populateHours();
        navigationService.getNavigation().then(nav => vm.navigation = nav);
        var loadReportPromise = checkListsService.getHourlyCheckReport(
          vm.plant.id,
          vm.wellKnownCheck,
          vm.numHours)
          .then((results) => {
            vm.hourlyReportItems = results;
            populateShopJobItems();
            _.forEach(vm.plant.shops, shop => {
              vm.hubs.push(kpiChecksHubService.createKPIChecksHub((updated: apsEvents.WellKnownCheckUpdated) => {
                var row = _.find(vm.shopJobItems, { shop: shop });
                if (!row) {
                  return;
                }
                var diff = moment().startOf('hour').diff(updated.eventDate, 'hours');
                if (diff > vm.numHours) {
                  return;
                }
                var hour = moment(updated.eventDate).utc().hour();
                var index = _.findIndex(vm.hours, { utcHour: hour });
                if (index < 0) {
                  return;
                }
                $timeout(() => {
                  row.hours[index].result = updated.result;
                  row.hours[index].status = updated.status;
                });
              }, shop.id, vm.wellKnownCheck));
            });
          });
        loaderService.loadingPromise(loadReportPromise);
        RefreshScreen(false, false);
      }, refreshtime);
      dataTimeout.push(timeOut);
    }
  }

  function getHourValue(offset: number, now: Date) {
    return moment.tz(now, vm.plant.timeZoneId).add(-1 * offset, 'hours').hour();
  }

  function getUTCHourValue(offset: number, now: Date) {
    return moment(now).utc().add(-1 * offset, 'hours').hour();
  }

  function createHourEntry(offset: number, now: Date) {
    var hour = getHourValue(offset, now);
    var utcHour = getUTCHourValue(offset, now);
    return {
      hour: hour,
      utcHour: utcHour,
      paddedHour: _.padStart(hour.toString(), 2, '0')
    };

  }

  function populateHours() {
    var now = new Date();
    /*  vm.hours = _.map(_.range(vm.numHours).reverse(), i => createHourEntry(i, now)); */
    vm.hours = _.map(_.range(vm.numHours), i => createHourEntry(i, now));

  }

  function getCheckItem(hourlyItem: apsViewModels.HourlyCheckReportShopItem, utcHour: number) {
    if (!hourlyItem) {
      return null;
    }

    return _.find(hourlyItem.checkInstances, function (ci) {
      return ci.utcHour === utcHour;
    });
  }

  function goToShopDashboard(plant: Plant, shop: apsViewModels.ShopNavigation) {
    vm.navigation.selectPlantShop(plant, shop);
    $state.go(States.DASHBOARD, { plantId: plant.id, shopId: shop.id, userId: $stateParams.userId });
  }
  vm.goToShopDashboard = goToShopDashboard;

  function goToProductionSummary(plant: Plant, shop: apsViewModels.ShopNavigation) {
    vm.navigation.selectPlantShop(plant, shop);
    $state.go(States.COUNT_SUMMARY, { plantId: plant.id, shopId: shop.id, userId: $stateParams.userId });
  }

  vm.goToProductionSummary = goToProductionSummary;
  function populateShopJobItems(): void {
    var items = [];
    var shopCount = 0;
    var shopDailyTotal = 0;
    _.forEach(vm.plant.shops, shop => {
      var hourStatus = [];
      var dailyStatus = [];
      var isJCIndicator = false;
      var reportItem = _.find(vm.hourlyReportItems, { shopId: shop.id });
      _.forEach(vm.hours, hour => {
        var checkItem = getCheckItem(reportItem, hour.utcHour);

        if (checkItem) {
          if (hour.utcHour === 99) {
            if (checkItem.result !== "00.0") {
              shopCount++;
            }
            shopDailyTotal = (shopDailyTotal + parseFloat(checkItem.result));
            dailyStatus.push({ result: checkItem.result, status: checkItem.status, isCaution: false, jobRunId: checkItem.jobRunId });
          } else {

            hourStatus.push({ result: checkItem.result, status: checkItem.status, isCaution: false, jobRunId: checkItem.jobRunId });
          }
        } else {
          hourStatus.push({ result: null, status: apsEnums.CheckStatus.NotDone, isCaution: false, jobRunId: null });
        }
      });

      if (!reportItem) {
        items.push({
          shop: shop,
          jobRun: {
            id: 'N/A',
            jobId: 'N/A',
            jobName: 'N/A',
            jobDescription: 'N/A',
            jobMold: 'N/A',
            jobFinish: 'N/A',
            jobGlassColorName: 'N/A',
            startDate: '',
            endDate: null,
            numberOfSections: 'N/A',
            machineDisabledSections: [],
            numberOfGobs: 'N/A',
            lehrTime: 'N/A',
            wareClassId: 'N/A'
          },
          day: 'N/A',
          hours: hourStatus,
          index: 0,
          jobRunCount: 1,
          isJCIndicator: isJCIndicator
        });
        return;
      }

      var index = 0;
      var jobRunCount = reportItem.jobRuns.length;
      _.forEach(reportItem.jobRuns, (jobRun, index) => {
        isJCIndicator = false;
        jobRun.currentRunAverageStr = jobRun.currentRunAverage.toFixed(1);

        if (index === 0 &&
            jobRunCount > 1 &&
            index < jobRunCount - 1 &&
            jobRun.jobId !== reportItem.jobRuns[index + 1].jobId &&
            jobRun.jobMold !== "9999" //Do now display the JC Indicator for Shut Down status; Job Mold for Shut Down is 9999
            )
        {
          isJCIndicator = true;
        }

        _.forEach(hourStatus, hrs => {

          var hrResult = parseFloat(hrs.result);
          if (hrResult != null) {
            var foundJobRun = _.filter(reportItem.jobRuns, x => x.id === hrs.jobRunId);
            if (foundJobRun.length > 0) {
              var percentDistance = foundJobRun[0].packPercentageTarget - hrResult;
              if (percentDistance > 0 && percentDistance <= 2) {
                hrs.isCaution = true;
              }

            }
          }

          if (hrs.result != null) {
            if (hrs.result.indexOf('0') === 0) {
              hrs.result = "\u00A0" + hrs.result.substr(1);
            }
          }
        });
        items.push({
          shop: shop,
          jobRun: jobRun,
          hours: hourStatus,
          dailies: dailyStatus,
          index: index,
          day: calculateDay(jobRun),
          jobRunCount: jobRunCount,
          isJCIndicator: isJCIndicator
        });
        index++;
      });
    });
    vm.shopJobItems = items;
    vm.plantAvg = (shopDailyTotal / shopCount).toFixed(1);
  }

  vm.showDetails = false;
  vm.toggleHidding = function toggleHidding(): void {
    vm.showDetails = !vm.showDetails;
  };

  //Temporarily only show the Yield column if they have the Production Report role
  vm.showYieldColumn = authDataService.isProductionShiftReport();

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/hourlyCheckReport.controller.ts